import { applyCsrfHeader, isCsrfMismatch } from './CsrfToken';
import { SessionExpiryNotifier } from './SessionExpiryNotifier';

/**
 * Fetch wrapper that includes session cookies, attaches the CSRF token on
 * mutating requests, retries once when the CSRF cookie was rotated under us
 * (e.g. during a silent refresh), and signals session expiry on 401.
 */
export async function authenticatedFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    let res = await sendWithCsrf(input, init);

    if (await isCsrfMismatch(res)) {
        res = await sendWithCsrf(input, init);
        if (await isCsrfMismatch(res)) {
            SessionExpiryNotifier.notifyExpired();
            return res;
        }
    }

    const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
    const isAuthProbe = url.includes('/api/auth/') || url.includes('/api/me');
    if (res.status === 401 && !isAuthProbe) {
        console.error('[AuthFetch] 401 on', input, '— session expired');
        SessionExpiryNotifier.notifyExpired();
    }

    return res;
}

/** Sends the request with credentials and a freshly-read CSRF header. */
function sendWithCsrf(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    const headers = applyCsrfHeader(init?.method, new Headers(init?.headers));
    return fetch(input, { ...init, headers, credentials: 'include' });
}
